import styled from "styled-components";

export const ContainerModalAlerta = styled.div`
  width: 359px;
  height: 317px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 8px;
  color: var(--color-white);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  z-index: 50;
  p {
    width: 90%;
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
  }
  button {
    width: 300px;
    height: 45px;
    border: 2px solid var(--color-white);
    border-radius: 8px;
    background-color: transparent;
    color: var(--color-white);
    font-size: 18px;
  }

  .backgorund-containerModalAutoT {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    z-index: -40;
    background: hsla(0, 0%, 0%, 0.5);
  }
  .cruz-circle {
    border: 3.5px solid var(--color-white);
    width: max-content;
    height: max-content;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }
`;

export const BackgroundModalAlerta = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  z-index: 20;
  background: hsla(0, 0%, 0%, 0.5);
`;
